import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "./experience.css";

const jobs = [
  {
    role: "Information Technology Intern",
    org: "University of Central Oklahoma",
    location: "Edmond, OK",
    period: "JAN 2026 – Present",
    bullets: [
      "Researched and integrated digital accessibility and compliance resources into the TeamDynamix (TDX) knowledge base.",
      "Created documentation to inform staff and faculty of DOJ accessibility rulings and requirements.",
      "Supported the Project Management team with coordination and deployment of new campus software.",
    ],
  },
  {
    role: "IT Intern",
    org: "Trinity School at Edgemere",
    location: "Oklahoma City, OK",
    period: "SEP 2025 – JAN 2026",
    bullets: [
      "Implemented network segmentation to staff devices to improve performance and security.",
      "Assisted in troubleshooting hardware, software, and connectivity issues.",
    ],
  },
  {
    role: "Guest Service Coordinator",
    org: "PMC",
    location: "Oklahoma City, OK",
    period: "FEB 2023 – JAN 2026",
    bullets: [
      "Demonstrated excellent communication and customer service while managing staff and performing operational audits.",
      "Implemented operational security measures to prevent theft and unauthorized access to sensitive material.",
      "Engaged in special projects requiring custom configurations to improve security posture.",
    ],
  },
];

function Experience() {
  const ref = useScrollReveal();

  return (
    <section ref={ref} id="experience" className="experience reveal">
      <div className="section-inner">
        <div className="section-header reveal-child" style={{ '--i': 0 }}>
          <span className="section-number font-mono">03</span>
          <h2 className="section-title">Experience</h2>
        </div>

        <div className="exp-timeline">
          {jobs.map((job, i) => (
            <div className="exp-item reveal-child" key={i} style={{ '--i': i + 1 }}>
              <div className="exp-header">
                <div>
                  <span className="exp-role">{job.role}</span>
                  <span className="exp-org font-mono"> — {job.org}, {job.location}</span>
                </div>
                <span className="exp-period font-mono">{job.period}</span>
              </div>
              <ul className="exp-bullets">
                {job.bullets.map((b, j) => <li key={j}>{b}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
